import React from "react"
import "./navigational-card-item.scss"
import Svg from "../_svgs/svg"

function NavigationalCardItem(props) {
  const item = props.item
  const cardLinkUrl = item.cardLinkUrl
  const cardHeading = item.cardHeading
  const icon = item.icon

  const upload = item.iconUpload
  let { value } = icon[0] || ""

  if (value === "None") {
    value = undefined
  }

  return (
    <div className="nav-card-container grid-item col--12 col-sm--6 col-md--4">
      <a href={`${cardLinkUrl || ""}`}>
        {value ? <Svg iconName={value} fillColor={"transparent"} stroke={"#071342"} /> : upload ? <img src={upload} alt="" /> : null}
        <h3 className="nav-card-header">{cardHeading}</h3>
      </a>
    </div>
  )
}

export default NavigationalCardItem
